import { dialerTypes } from 'modules/common/constants/conversationInitiatorTypes';
import { joinToConsultation } from 'modules/conference/actions/startConsultation';
import { showAppointmentInfo } from 'modules/queues/common/actions/appointmentInfo';
import { FETCH_APPOINTMENT } from 'modules/appointmentInfo/actions/fetchAppointment';
import { currentConversation } from 'modules/appointmentInfo/selectors/currentAppointment';
import { CONNECTING, DECLINED, IN_PROGRESS, PENDING } from 'modules/common/constants/conversationStatuses';
import { updateConversation } from 'modules/conference/actions/_newConversationActions/updateConversation';

import createAction from '../';


export const DECLINE_CONSULTATION = createAction('DECLINE_CONSULTATION');
export const CONNECTING_TO_CONSULTATION = createAction('CONNECTING_TO_CONSULTATION');

export const declineConsultation = appointmentId => dispatch => {
  dispatch(updateConversation(DECLINED, appointmentId))
    .then(() => dispatch({ type: DECLINE_CONSULTATION }));
};

export const connectToConversation = (appointmentId, appointment) => (dispatch, getState) => {
  const status = dialerTypes.includes(currentConversation(getState()).initiator) ? PENDING : CONNECTING;

  const schedules = appointment.schedules.filter(({ status }) => status === 'CREATED');

  dispatch({
    type: FETCH_APPOINTMENT.success,
    payload: { appointment: { ...appointment, schedules } },
  });

  dispatch({ type: CONNECTING_TO_CONSULTATION });

  dispatch(showAppointmentInfo(appointmentId))
    .then(() => dispatch(updateConversation(status, appointmentId)))
    .then(() => dispatch(joinToConsultation()));
};

export const setConversationInProgress = () => updateConversation(IN_PROGRESS);
